import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

import ItemLine from './ItemLine'

/**
 * 対象がLabelLineProps型かチェックする
 * @param target チェック対象
 */
export const isLabelLineProps = (target: any): target is LabelLineProps => {
  return target.label !== undefined
}

/**
 * ラベル行
 */
const LabelLine: React.FC<LabelLineProps> = (props) => {
  return (
    <ItemLine showLineBorder lineOffset="18px" variableHeight>
      <TextArea>
        <Text>{props.label}</Text>
      </TextArea>
    </ItemLine>
  )
}

export type LabelLineProps = {
  label: string
}

const TextArea = styled.div`
  margin: 10px 18px;
`

export default LabelLine
